// Infinite-scroll pages can overlap (offset-based pagination shifting as the
// underlying list changes between page fetches), producing exact-duplicate
// items across pages that collide on the same React/table row key. Drop
// repeats, keeping the first occurrence.
export function dedupeByKey<T>(
  items: T[],
  keyFn: (item: T, index: number) => string | number
): T[] {
  const seen = new Set<string | number>();
  return items.filter((item, i) => {
    const key = keyFn(item, i);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
